import { imgMap } from 'BlockChain-ui-privatization/utils';
import imgMapObj from '@/utils/imgMap.json';

const imgMapSlove = imgMap(imgMapObj[1], process.env.BASE_URL);

export { imgMapSlove as imgMap };

export {
  getDigit,
  // fixDEAdd,
  // setCoMarket,
  setDefaultMarket,
  logImg,
  debounce,
  accMul,
  accSubtr,
  add, // 加法
  cut, // 减法
  division, // 乘法
  nul, // 除法3
  fixRate,
  formatTime,
  formatDateTime,
  fixD,
  diff,
  lastD,
  fixUrl,
  fixInput,
  getScript,
  getComplexType,
  getTime,
  timeFn,
  fixFloat,
  getHex,
  routerEnv,
  colorMap,
  myStorage,
  browser,
  getLocationLang,
  getCoinShowName,
  thousandsComma,
  getCountryList,
  setCookie,
  getCookie,
  removeCookie,
} from 'BlockChain-ui-privatization/utils';

function getCurrentHost() {
  let host = window.location.host;
  // if (host.indexOf('localhost') > -1) {
  host = process.env.VUE_APP_HOST;
  // }
  return host;
}

function getCurrentProtocol() {
  const protocol = window.location.protocol;
  const host = window.location.host;
  let wsStart = protocol.indexOf('https') > -1 ? 'wss' : 'wss';
  if (host.indexOf('localhost') > -1) {
    wsStart = 'wss';
  }
  return wsStart;
}

/**
 * 获取现货ws地址
 */
export function getSpotWsUrl() {
  const host = getCurrentHost();
  const wsStart = getCurrentProtocol();
  return `${wsStart}://${host}/ews/kline-api/ws`;
}

/**
 * 获取合约ws地址
 */
export function getFutureWsUrl() {
  const host = getCurrentHost();
  const wsStart = getCurrentProtocol();
  return `${wsStart}://${host}/fws/kline-api/ws`;
}

/**
 * 获取otc聊天ws地址
 */
export function getChatWsUrl() {
  const host = getCurrentHost();
  const wsStart = getCurrentProtocol();
  return `${wsStart}://${host}/otc-chat/chatServer`;
}
